/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { PledgInstallmentsBody } from '../../../../../com/hcl/commerce/typescript/axios';
// @ts-ignore
import { Result } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * GetPledgInstallmentsApi - axios parameter creator
 * @export
 */
export const GetPledgInstallmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch Pledg Installments
         * @summary Fetch Pledg installments prices for purchase
         * @param {string} storeId The store identifier.
         * @param {PledgInstallmentsBody} body The body data required for the REST method.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pledgInstallments: async (storeId: string, body: PledgInstallmentsBody, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('pledgInstallments', 'storeId', storeId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('pledgInstallments', 'body', body)
            const localVarPath = `/store/{storeId}/resources/payment/getPledgeInstallment`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GetPledgInstallmentsApi - functional programming interface
 * @export
 */
export const GetPledgInstallmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GetPledgInstallmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetch Pledg Installments
         * @summary Fetch Pledg installments prices for purchase
         * @param {string} storeId The store identifier.
         * @param {PledgInstallmentsBody} body The body data required for the REST method.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pledgInstallments(storeId: string, body: PledgInstallmentsBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pledgInstallments(storeId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GetPledgInstallmentsApi - factory interface
 * @export
 */
export const GetPledgInstallmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GetPledgInstallmentsApiFp(configuration)
    return {
        /**
         * Fetch Pledg Installments
         * @summary Fetch Pledg installments prices for purchase
         * @param {string} storeId The store identifier.
         * @param {PledgInstallmentsBody} body The body data required for the REST method.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pledgInstallments(storeId: string, body: PledgInstallmentsBody, options?: any): AxiosPromise<Result> {
            return localVarFp.pledgInstallments(storeId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GetPledgInstallmentsApi - object-oriented interface
 * @export
 * @class GetPledgInstallmentsApi
 * @extends {BaseAPI}
 */
export class GetPledgInstallmentsApi extends BaseAPI {
    /**
     * Fetch Pledg Installments
     * @summary Fetch Pledg installments prices for purchase
     * @param {string} storeId The store identifier.
     * @param {PledgInstallmentsBody} body The body data required for the REST method.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetPledgInstallmentsApi
     */
    public pledgInstallments(storeId: string, body: PledgInstallmentsBody, options?: any) {
        return GetPledgInstallmentsApiFp(this.configuration).pledgInstallments(storeId, body, options).then((request) => request(this.axios, this.basePath));
    }
}
